import * as React from "react";
const SvgFiRrHandPointRibbon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hand-point-ribbon_svg__a)">
      <path
        fill="#062147"
        d="M20.943 8.714a3.01 3.01 0 0 0-2.439-.674 2.88 2.88 0 0 0-1.494.749 2.98 2.98 0 0 0-2.01-.79 2.98 2.98 0 0 0-2 .78A2.98 2.98 0 0 0 11 8V3.108C11 1.59 9.924.273 8.497.04a3 3 0 0 0-2.439.674A3 3 0 0 0 5.001 3v1H1.617c-.549 0-.766.526-.378.914L3.001 6 1.252 7.119c-.388.388-.183.882.365.882H5v3.547c-.04.036-1.41 1.383-1.41 1.383A5.37 5.37 0 0 0 2 16.757a5.38 5.38 0 0 0 1.584 3.829l1.072 1.072A7.95 7.95 0 0 0 10.313 24H17c2.757 0 5-2.243 5-5V11c0-.881-.385-1.714-1.057-2.286M14 11c0-.551.449-1 1-1s1 .449 1 1v2c0 .55-.449 1-1 1s-1-.45-1-1zm-4 0c0-.551.449-1 1-1s1 .449 1 1v2c0 .55-.449 1-1 1s-1-.45-1-1zM7 3c0-.294.128-.572.353-.762a1.01 1.01 0 0 1 .823-.224c.462.076.825.556.825 1.093V4h-2zm0 5h2v.78a2.98 2.98 0 0 0-.995 2.175A3 3 0 0 0 7 10.772zm13 11c0 1.654-1.346 3-3 3h-6.687a5.96 5.96 0 0 1-4.243-1.757L4.998 19.17a3.4 3.4 0 0 1-.999-2.414 3.38 3.38 0 0 1 1.002-2.411l1.287-1.283a1.001 1.001 0 0 1 1.706.708.99.99 0 0 1-.294.707l-1.408 1.405a1 1 0 1 0 1.414 1.416l1.408-1.405c.112-.111.205-.235.296-.36a2.97 2.97 0 0 0 1.589.466 2.98 2.98 0 0 0 2-.78c.532.48 1.229.78 2 .78a2.98 2.98 0 0 0 2-.78 2.98 2.98 0 0 0 3 .609zm0-6c0 .55-.449 1-1 1s-1-.45-1-1v-2a1 1 0 0 1 2 0z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hand-point-ribbon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHandPointRibbon;
